export function formatoMonto(e) {
  const monto = e.target.value;
  const cantidad = monto.replace(/[^0-9\\.]+/g, "");
  /*return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cantidad);*/
  return Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(cantidad);
}

export function MotoSinFormato(monto) {
  return monto.replace(/[^0-9\\.]+/g, "");
}

export function FormatoCantidad(
  numero,
  decimales,
  separador_decimal,
  separador_miles,
) {
  numero = parseFloat(numero);
  if (isNaN(numero)) {
    return "";
  }
  if (decimales !== undefined) {
    // Redondeamos
    numero = numero.toFixed(decimales);
    //console.log(numero);
  }
  // Convertimos el punto en separador_decimal
  numero = numero
    .toString()
    .replace(".", separador_decimal !== undefined ? separador_decimal : ",");
  if (separador_miles) {
    // Añadimos los separadores de miles
    var miles = new RegExp("(-?[0-9]+)([0-9]{3})");
    while (miles.test(numero)) {
      numero = numero.replace(miles, "$1" + separador_miles + "$2");
    }
  }
  return numero;
}

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  //return [year, month, day].join('-');
  return [day, month, year].join("/");
}

export function revertDate(date) {
  let dia = date.substr(0, 2),
    mes = date.substr(3, 2),
    anio = date.substr(6, 4);
  let newDate = new Date(anio + "/" + mes + "/" + dia);
  return newDate;
}

export function readFile(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (x) => {
      let archivo = reader.result;
      let validExtensions = [
        "data:image/jpeg;base64,",
        "data:image/png;base64,",
        "data:image/bmp;base64,",
        "application/pdf;base64,",
      ];
      let separacionArchivo = Array;
      for (let i = 0; i < validExtensions.length; i++) {
        separacionArchivo = archivo.split(validExtensions[i]);

        if (separacionArchivo[1] !== undefined) {
          break;
        }
      }
      resolve(separacionArchivo[1]);
    };
    reader.onerror = (error) => reject(error);
  });
}

export function extensionArchivo(type) {
  let tipoArchivo = "";
  if (type === "image/png") {
    tipoArchivo = "PNG";
  } else if (type === "application/pdf") {
    tipoArchivo = "PDF";
  } else if (type === "image/jpeg") {
    tipoArchivo = "JPG";
  }
  return tipoArchivo;
}

export function etiquetaDoc(nameFile) {
  let etiquetaDocumento = "";
  if (nameFile === "frenteINE") {
    etiquetaDocumento = "FIOKD";
  } else if (nameFile === "reversoIne") {
    etiquetaDocumento = "RIOKD";
  } else if (nameFile === "comprobanteDomicilio") {
    etiquetaDocumento = "CIKD";
  } else if (nameFile === "documentosAdicionales") {
    etiquetaDocumento = "DOCADKD";
  }
  return etiquetaDocumento;
}

export function getLogoSrc(aseguradora, logo_url = null) {
  if (logo_url && logo_url !== "") {
    return logo_url;
  }
  return "";
}

export function iconEstatus(estatus) {
  let iconClass = "icon-info";
  if (estatus === "cancel") {
    iconClass = "icon-error";
  } else if (estatus === "ok") {
    iconClass = "icon-success";
  } else if (estatus === "warning") {
    iconClass = "icon-warning";
  }
  return iconClass;
}

export function formatNombreMayus(value) {
  if (!value) return "";
  return value
    .toUpperCase()
    .replace(/[ÁÀÄÂÃ]/g, "A")
    .replace(/[ÉÈËÊ]/g, "E")
    .replace(/[ÍÌÏÎ]/g, "I")
    .replace(/[ÓÒÖÔÕ]/g, "O")
    .replace(/[ÚÙÜÛ]/g, "U")
    .replace(/[^A-ZÑ. ]/g, "");
}

export function nombreVendedor(vendedor) {
  if (!vendedor) return "";
  const nombre = [
    vendedor.nombre,
    vendedor.primerApellido,
    vendedor.segundoApellido,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  return nombre || vendedor.email || "";
}

export function inputSinEspacios(e) {
  if (e.key === " ") {
    e.preventDefault();
  }
}

export function eliminacionEspacionPegar(e) {
  if (e.currentTarget.value.includes(" ")) {
    e.currentTarget.value = e.currentTarget.value.replace(/\s/g, "");
  }
}

export function geolocalizacion() {
  return new Promise((resolve) => {
    // Coordenadas por defecto (CDMX)
    const coordenadasDefault = { code: 0, lt: 19.42847, lg: -99.12766 };

    // Timeout de 5 segundos
    const timeoutId = setTimeout(() => {
      resolve(coordenadasDefault);
    }, 5000);

    if (!navigator.geolocation) {
      clearTimeout(timeoutId);
      resolve(coordenadasDefault);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        clearTimeout(timeoutId);
        let cordenadas = { code: 0, lt: coords.latitude, lg: coords.longitude };
        resolve(cordenadas);
      },
      (err) => {
        clearTimeout(timeoutId);
        console.log("Error en geolocalización:", err.message);
        resolve(coordenadasDefault);
      },
      {
        timeout: 5000,
        maximumAge: 300000, // 5 minutos
        enableHighAccuracy: false,
      },
    );
  });
}
